import { createClient } from '@/shared/api';
import type { UnreviewedReportCountQuery, UnreviewedReportCountQueryVariables } from '@/shared/api';
import UNREVIEWED_REPORT_COUNT_QUERY from '../queries/unreviewedReportCount';

/**
 * Loads the number of unreviewed reports matching a filter. Runs the unreviewedReportCount query and throws the returned message unless it reports success, otherwise yielding the count.
 *
 * @param filter - Filter narrowing the counted reports.
 * @returns A promise resolving to the unreviewed report count.
 */
const fetchUnreviewedReportCount = async (
  filter: UnreviewedReportCountQueryVariables['filter'],
): Promise<NonNullable<UnreviewedReportCountQuery['unreviewedReportCount']>['count']> => {
  const client = createClient();
  const result = await client.query<
    UnreviewedReportCountQuery,
    UnreviewedReportCountQueryVariables
  >({
    query: UNREVIEWED_REPORT_COUNT_QUERY,
    variables: { filter },
  });
  const { data } = result;
  // API always returns this field for a resolved query; code already accessed it unconditionally.
  const { unreviewedReportCount } = data;
  if (!unreviewedReportCount!.isSuccess) {
    throw new Error(unreviewedReportCount!.message ?? undefined);
  }
  return unreviewedReportCount!.count;
};

export default fetchUnreviewedReportCount;
